import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChatWidget } from './components/ChatWidget';
import './styles.css';

// Get configuration from global window object or Vite env
declare global {
  interface Window {
    UHAVEN_CHAT_CONFIG?: {
      apiBaseUrl?: string;
      privacyUrl?: string;
    };
  }
}

// Priority: window config > Vite env > empty (uses relative URLs via proxy in dev)
const apiBaseUrl = window.UHAVEN_CHAT_CONFIG?.apiBaseUrl
  || import.meta.env.VITE_API_URL
  || '';

// Link shown next to the "don't share personal information" notice. Optional on
// purpose: the widget must not render a link to a privacy statement that does not
// exist yet, so leave it unset until uHaven publishes one, then set it in the Duda
// embed snippet without redeploying the widget.
const privacyUrl = window.UHAVEN_CHAT_CONFIG?.privacyUrl
  || import.meta.env.VITE_PRIVACY_URL
  || '';

// Find or create mount point
let rootElement = document.getElementById('uhaven-chat-root');
if (!rootElement) {
  rootElement = document.createElement('div');
  rootElement.id = 'uhaven-chat-root';
  document.body.appendChild(rootElement);
}

// Mount the widget
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ChatWidget apiBaseUrl={apiBaseUrl} privacyUrl={privacyUrl} />
  </React.StrictMode>
);
